// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { setDataToCookie } from 'aster-foundation/core/common/utils/cookieHelper';
import { makeTraceId } from './src/Common/Utility/common-utils';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: SENTRY_DSN || 'https://34fd1a005769f210fadfc23d80797910@sentry.myastertools.com/4',
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.2,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENV,
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
  });

  const traceId = makeTraceId();
  Sentry.configureScope((scope) => {
    setDataToCookie("traceId", traceId);
    scope.setTag("traceId", traceId);
  });

}
